export const HEADERS = [
	'No.',
	'Type',
	'Subject',
	'Recipients',
	'Schedule (UTC)',
	'Active',
	'Actions',
];
